export default "__VITE_ASSET__BUaV$oBl__"